import AlphaHelpers from '../abstracts/classes/alpha-helpers'

document.addEventListener('DOMContentLoaded', () => {
  // determine if element is inside top bar, header etc.
  const getElementLayoutPosition = (el) => {
    const layoutPositions = {
      '.top-bar': 'top',
      '.header-wrapper': 'header',
      '.site-main': 'content',
      '.site-footer': 'footer'
    }

    for (const selector in layoutPositions) {
      if (el.closest(selector)) {
        return layoutPositions[selector]
      }
    }

    return 'unknown'
  }

  const setElementEventAttributes = (el, action, label) => {
    el.setAttribute(AlphaHelpers.getGaEventAttributeName('on'), 'click')
    el.setAttribute(AlphaHelpers.getGaEventAttributeName('category'), `zone: ${getElementLayoutPosition(el)}`)
    el.setAttribute(AlphaHelpers.getGaEventAttributeName('action'), action)
    el.setAttribute(AlphaHelpers.getGaEventAttributeName('label'), label)
  }

  // add events on contact links (tel, mailto)
  const notSelector = ':not([data-ga-event-on])'
  const contactLinks = AlphaHelpers.smartQuerySelectorAll(`[href^="tel:"]${notSelector}, [href^="mailto:"]${notSelector}, [href^="javascript:DeCryptX"]${notSelector}`)
  contactLinks.forEach((linkEl) => {
    let href = linkEl.href
    if (AlphaHelpers.isCryptX(href)) {
      href = AlphaHelpers.decryptX(href)
    }

    const linkType = href.split(':')[0]
    let action = ''
    switch (linkType) {
      case 'tel':
        action = 'click_phone'
        break
      case 'mailto':
        action = 'click_mailto'
        break
      default:
        break
    }

    if (action.length) {
      let label = href.replace(/(tel|mailto):/, '')

      switch (linkType) {
        case 'mailto':
          label = ''
          break
        default:
          break
      }

      setElementEventAttributes(linkEl, action, label)
    }
  })

  // add events on social links (obfuscated or not)
  const obLinkAttrName = 'data-oblink-href'
  const socialLinks = AlphaHelpers.smartQuerySelectorAll(`.social-links [href], .social-links [${obLinkAttrName}]`)
  socialLinks.forEach((linkEl) => {
    const obfuscated = linkEl.hasAttribute(obLinkAttrName)
    const label = obfuscated ? atob(linkEl.getAttribute(obLinkAttrName)) : linkEl.href
    setElementEventAttributes(linkEl, 'click_social_link', label)
  })
})
